<script setup lang="ts">
import { ref, watch } from 'vue'
import { useHistory } from './composables/useHistory'
import HistoryChart    from './components/HistoryChart.vue'
import HistoryBarChart from './components/HistoryBarChart.vue'
import HistoryList     from './components/HistoryList.vue'
import type { HistoryChartView } from './lib/historyBarHelpers'

const { entries, deleteEntry } = useHistory()

const ls = localStorage

const chartView  = ref<HistoryChartView>((ls.getItem('hist_chart_view')  as HistoryChartView)  || 'line')

watch(chartView,  v => ls.setItem('hist_chart_view',  v))

function exportCSV() {
  if (!entries.value.length) { alert('No history to export.'); return }
  window.exportHistory?.()
}

function deleteAllContent() {
  void window.deleteAllContent?.()
}
</script>

<template>
  <div class="card history-card">
    <template v-if="entries.length">
      <HistoryChart    v-if="chartView === 'line'" :entries="entries" />
      <HistoryBarChart v-else :entries="entries" />
    </template>

    <div class="hist-controls hist-controls--below-chart">
      <div class="hist-view-toggle" aria-label="Graph type">
        <button
          type="button"
          :class="{ active: chartView === 'line' }"
          @click="chartView = 'line'"
        >Line</button>
        <button
          type="button"
          :class="{ active: chartView === 'bar' }"
          @click="chartView = 'bar'"
        >Bar</button>
      </div>

    </div>

    <div v-if="!entries.length" style="color:var(--muted);font-size:13px;margin-top:8px;">
      No scores saved yet. Calculate and save a score to track progress.
    </div>

    <div v-if="entries.length" class="history-section-head">
      <div class="card-title">Score History</div>
      <button class="btn btn-secondary history-export" type="button" @click="exportCSV">
        Export CSV
      </button>
    </div>

    <HistoryList
      v-if="entries.length"
      :entries="entries"
      paginate
      :page-size="5"
      @delete="deleteEntry"
    />
  </div>

  <button class="btn btn-danger history-delete-all" type="button" @click="deleteAllContent">
    Delete all content
  </button>
</template>
